import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Button, Modal } from 'semantic-ui-react';

const ConfirmationModal = ({ children, onContinue }) => {
	const [open, setOpen] = useState(false);

	return (
		<Modal open={open} onOpen={() => setOpen(true)} onClose={() => setOpen(false)} trigger={children} size='small'>
			<Modal.Header>CAUTION!!!</Modal.Header>
			<Modal.Content>
				You are about to make a change to your personal auto insurance policy. <b>Depending on the change you are making, this may result in a reduction or elimination of coverage for a vehicle or a driver or a failure to fulfill your obligations to the lienholder.</b> Please check the changes you are making to be certain that they are what you intend.
			</Modal.Content>
			<Modal.Actions>
				<Button
					id="continueBtn"
					primary
					onClick={() => {
						setOpen(false);
						onContinue();
					}}>
					Continue
				</Button>
				<Button id="cancelBtn" primary onClick={() => setOpen(false)}>
					Cancel
				</Button>
			</Modal.Actions>
		</Modal>
	);
};

ConfirmationModal.propTypes = {
	children: PropTypes.any.isRequired,
};

export default ConfirmationModal;
